import { cartTotalStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingCartTotal";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { cartLineQuantityStyles } from "@tCooneyBrothers/Overrides/Widgets/Cart/CartLineQuantity";
import { css } from "styled-components";

cartLineQuantityStyles.editableQuantityTextField = {
    labelProps: {
        variant: "legend",
    },
    cssOverrides: {
        formInputWrapper: css`
            input[type="number"]::-webkit-outer-spin-button,
            input[type="number"]::-webkit-inner-spin-button {
                /* ISC-11023 deal with this. */
                /* stylelint-disable-next-line */
                -webkit-appearance: none;
                margin: 0;
            }
            input[type="number"] {
                -moz-appearance: textfield !important;
            }
        `,
    },
};
